export enum CustomerType {
  Individual = 'Bireysel',
  Corporate = 'Kurumsal'
}
